export default "__VITE_ASSET__B2iPQ2OA__"